<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar a tabela de preço <b>{{this.entry.description}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(tablePrice) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_TABLE_PRICE_MUTATION,
          variables: {
            id: tablePrice.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyTablePrice.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_TABLE_PRICE_MUTATION = gql `
  mutation($id: ID!) {
    destroyTablePrice(id: $id) {
      tablePrice {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>